import React from 'react';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { ChangeCardAndDetails } from '../PolicyChangeCard';
import {
  PolicyChangeCard,
  changeTypes,
} from '../PolicyChangeCard/PolicyChangeCard';
import { DisplayAddress } from '@clearcover/core-app-types/dist/endpoints/getPolicy/displayAddress';
import { AddressChangeDetails } from './AddressChangeDetails';

export const toAddressChangeCardAndDetails = (
  diff: VersionedObjectDiff<DisplayAddress>
): ChangeCardAndDetails => {
  const displayType = diff.type;
  const title = `Address ${changeTypes[displayType]}`;
  const value = 'Changes';

  return {
    card: ({ 'data-testid': dataTestId, selected, onClick }) => (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={title}
        onClick={onClick}
        selected={selected}
        type="address"
        action={displayType}
        value={value}
      />
    ),
    details: () => <AddressChangeDetails diff={diff} />,
    metadata: {
      type: 'address',
      action: displayType,
      title,
      value,
    },
  };
};
